module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-003"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_VII",
      "title": "VII"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_vm._v("Reformation Commentary on Scripture"), _c('br'), _vm._v("Project Staff")])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("Project Editor")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("David W. McNutt")]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig5"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/f1.jpg"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("Managing Editor")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Elissa Schauer")]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig6"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/f1.jpg"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("Copyeditor")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Jeffrey A. Reimer")]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig7"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/f1.jpg"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("Assistant Project Editor")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("André A. Gazal")]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig8"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/f1.jpg"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("Editorial and Research Assistants")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("David J. Hooper")]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Ashley Davila")]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("April Ponto")]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig9"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/f1.jpg"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("Assistants to the General Editors")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Bryan Just")]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Le-Ann Little")]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Jason Odom")]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig10"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/f1.jpg"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("Design")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Cindy Kiple")]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig11"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/f1.jpg"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("Design Assistant")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Beth McGill")]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig12"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/f1.jpg"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("Content Production")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Maureen G. Tobey")]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Daniel van Loon")]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Jeanna L. Wiggins")]), _c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig13"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "Illustration",
      "src": "images/f1.jpg"
    }
  })])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('i', [_vm._v("Proofreader")])]), _c('p', {
    staticClass: "txt_courant_centre"
  }, [_vm._v("Travis Ables")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 63
// module chunks = 0